import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PrintIcon from '@material-ui/icons/Print';
import MailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import PropTypes from 'prop-types';
import ThemeImages from '../theme/images';
import ThemeColors from '../theme/colors';
import appStore from '../../images/appstore.svg';
import googlePlay from '../../images/google-play.png';
import { Button } from '../components';
import Navbar from '../navbar_new';
import ENV from '../../run-config';
import poweredByLogo from '../../images/icon_whitelabel.png';
import LandingPageContent from './langingpage-content';
import { DefaultPlayer as HTML5Player } from 'react-html5video';
import LearningContent from '../main/course/learning-content';

const StyledButton = withStyles({
  root: {
    background: ThemeColors.primary1Color,
    padding: '5px 15px 5px 15px',
    borderRadius: 30,
  },
  label: {
    fontSize: 12,
    color: '#fff',
  },
})(Button);

const FooterButton = withStyles({
  root: {
    marginTop: 5,
    marginLeft: 0,
    paddingLeft: 0,
    textAlign: 'left',
    '&:hover': {
      background: 'none',
      borderRadius: 0,
      fontWeight: 'bold',
      color: 'black !important',
    },
  },
  label: {
    fontSize: 12,
    color: 'grey',
    textAlign: 'left',
    justifyContent: 'flex-start',
  },
})(Button);


class Landingpage extends Component {

  onLinkClicked = (link) => {
    window.open(link, '_blank');
  }

  handleNavigateToRoute = (route) => {
    this.props.history.push(route);
  }

  renderOnboardingButtons() {
    if (this.props.loggedIn) {
      return null;
    }
    return (
      <div>
        <StyledButton
          onClick={() => this.handleNavigateToRoute('signup')}
          style={{ marginRight: 10, marginBottom: 10 }}
        >
          Gastzugang
          </StyledButton>
        <StyledButton
          onClick={() => this.handleNavigateToRoute('login')}
          style={{ marginRight: 10, marginBottom: 10 }}
        >
          Login
           </StyledButton>
        <StyledButton
          onClick={() => this.handleNavigateToRoute('benutzerregistrierung')}
          style={{ marginBottom: 10 }}
        >
          Registrierung
           </StyledButton>
      </div>
    );
  }

  renderFolderArea() {
    if (!LandingPageContent.folderUrl) return null;
    const { classes } = this.props;

    return (
      <div>
        <div className={`container align-content-center ${classes.bodyContainer}`} style={{ marginBottom: 10 }}>
          <div className="col-md-6 col-sm-12  col-md-push-6 text-center" style={{ margin: '20px 0 20px 0' }} />
          <div className="col-md-6 col-sm-12 col-md-pull-6" style={{ margin: '55px 0 20px 0' }}>
            <Typography className={classes.headline}>Folder customerEXPERT</Typography>

          </div>
        </div>
        <div
          className={`container align-content-center ${classes.bodyContainer}`}
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <div>

            <img
              onClick={() => this.onLinkClicked(LandingPageContent.folderUrl)}
              src={ThemeImages.landingpageTitle}
              style={{ cursor: 'pointer', maxWidth: '50vw' }}
              alt="folder"
            />
            <Typography style={{ textAlign: 'left' }}>©Ristl/Grafik Design</Typography>


          </div>
        </div>
      </div>
    );
  }

  renderBlock(image, content, flexEnd) {
    const { classes } = this.props;

    return (
      <div
        className={`container align-content-center ${classes.bodyContainer}`}
        style={{
          marginBottom: 50,
          // display: 'flex'
        }}
      >
        <div
          className="col-md-6 col-sm-12 col-md-push-6 text-center"
          // className="col-md-6 col-sm-12"
          style={{
            display: 'flex',
            justifyContent: flexEnd ? 'flex-end' : 'center',
            flexDirection: flexEnd ? '' : 'column',
            paddingLeft: 30,
            marginTop: 20,
            minHeight: 300
          }}
        >
          {content}
        </div>
        <div
          style={{ marginTop: 10 }}
          className="col-md-6 col-sm-12 col-md-pull-6"
        // className="col-md-6 col-sm-12"
        >
          {image}
        </div>

      </div>
    );
  }

  renderFolder() {
    const { classes } = this.props;
    const listStyle = { listStyleType: 'circle', padding: 0, marginLeft: 5, textAlign: 'left' };

    const image = [
      <img
        onClick={() => this.onLinkClicked(LandingPageContent.folderUrl)}
        src={ThemeImages.landingpageTitle}
        style={{ width: '100%' }}
        alt="folder-image"
      />,
      <Typography>©Ristl/Grafik Design</Typography>,
    ];

    const content = [
      <Typography
        style={{ textAlign: 'left' }}
        className={classes.headline}
      >Folder customerEXPERT</Typography>,

        <ul style={listStyle}>
          <li style={listStyle}>Mehr Fachwissen und Kompetenz für Ihre Mitarbeiter</li>
          <li style={listStyle}>Mehr Service und Qualität für Ihre Kunden</li>
          <li style={listStyle}>Mehr Digitales Lernen, jederzeit und überall</li>
        </ul>,

      <StyledButton
        onClick={() => this.onLinkClicked(LandingPageContent.folderUrl)}
        style={{ marginTop: 20, borderRadius: 0, width: 'fit-content' }}
      >
      mehr erfahren
   </StyledButton>,
    ];

    return this.renderBlock(image, content);
  }


  renderVideo() {
    const { classes } = this.props;
    const image = [
      <img
        onClick={() => this.onLinkClicked('https://www.youtube.com/watch?v=eSVukf0MvvY')}
        src={ThemeImages.landingpageVideoPreview}
        style={{ width: '100%' }}
        alt="youtube-video"
      />,
      <Typography>©Gabler/Werbung, Film GmbH</Typography>,
    ];

    const content = [
      <Typography
        style={{ textAlign: 'left' }}
        className={classes.headline}
      >Unser Imageclip</Typography>,
      <Typography style={{ textAlign: 'left' }}>Erlebe unsere fachspezifische</Typography>,
      <Typography style={{ textAlign: 'left' }}>Wissens-App in unserem Video</Typography>,
      <StyledButton
        onClick={() => this.onLinkClicked('https://www.youtube.com/watch?v=eSVukf0MvvY')}
        style={{ marginTop: 20, borderRadius: 0, width: 'fit-content' }}
      >
  zum Video
   </StyledButton>,
    ];

    return this.renderBlock(image, content);
  }

  renderVideo2() {
    if (!LandingPageContent.videoUrl) return null;
    const { classes } = this.props;

    return (
      // <div>
      <div
        className={`container align-content-center ${classes.bodyContainer}`}
        style={{ marginBottom: 10, display: 'flex' }}
      >
        <div
          className="col-md-6 col-sm-12 col-md-push-6 text-center"
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            marginLeft: 30,
          }}
        >
          <Typography
            style={{ textAlign: 'left' }}
            className={classes.headline}
          >Unser Imageclip</Typography>
          <Typography style={{ textAlign: 'left' }}>Erlebe unsere fachspezifische</Typography>
          <Typography style={{ textAlign: 'left' }}>Wissens-App in unserem Video</Typography>
          <StyledButton
            onClick={() => this.handleNavigateToRoute('benutzerregistrierung')}
            style={{ marginTop: 10, borderRadius: 0, width: 'fit-content' }}
          >
          zum Video
           </StyledButton>

        </div>


        <div className="col-md-6 col-sm-12 col-md-pull-6">
          <img
            onClick={() => this.onLinkClicked('https://www.youtube.com/watch?v=eSVukf0MvvY')}
            src={ThemeImages.landingpageVideoPreview}
            style={{ width: '100%' }}
            alt="youtube-video"
          />
          <Typography>©Gabler/Werbung, Film GmbH</Typography>
          {/* <Typography className={classes.headline}>Folder customerEXPERT</Typography> */}

        </div>

      </div>

    );
  }

  renderHeader() {
    const { classes } = this.props;
    const headerImages = (
      <div className={`col-md-6 col-sm-12  col-md-push-6 text-center ${classes.headerImageContainer}`}>
        <div className="">
          <img
            src={ThemeImages.landingpageHeaderImage}
            alt="Landingpage Header"
            className={`${classes.headerImage} verticalAlign`}
          />
        </div>
        <div className={classes.appstoreContainer} />
      </div>
    );

    return (
      <div
        style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.8), rgba(255,255,255,0.8)), url(${ThemeImages.landingpageHeader})`,
          backgroundSize: 'cover',
        }}
      >
        <div
          style={{ paddingBottom: 90 }}
          className={`container ${classes.bodyContainer}`}
        >
          {headerImages}
          <div className="col-md-6 col-sm-12 col-md-pull-6">
            <Typography className={classes.headerPreHeadline}>
              {LandingPageContent.headerPreHeadline}
            </Typography>
            <Typography className={classes.headline}>
              {LandingPageContent.headerHeadlineLine1}
            </Typography>
            <Typography
              className={classes.headline}
              style={{ marginBottom: 40 }}
            >
              {LandingPageContent.headerHeadlineLine2}
            </Typography>
            <Typography className={classes.headerText}>
              {LandingPageContent.headerText}
            </Typography>
            <div className={classes.buttonContainer}>
              {this.renderOnboardingButtons()}

            </div>

          </div>

        </div>
      </div>
    );
  }

  renderAppPreview() {
    const { classes } = this.props;

    return (
      <div
        style={{
          justifyContent: 'center',
          display: 'flex',
        }}
        className={`container ${classes.bodyContainer}`}
      >
        <div style={{ maxHeight: 500, maxWidth: '50vw' }}>
          <img
            src={ThemeImages.landingpageHeader2}
            style={{
              marginTop: -100,
              marginBottom: 60,
              maxWidth: '100%',
            }}
            alt="playstore preview"
          />
        </div>
      </div>
    );
  }

  renderBody() {
    const { classes } = this.props;

    return (
      <div className={`container align-content-center ${classes.bodyContainer}`}>
        <div className="col-md-6 col-sm-12  col-md-push-6 text-center" style={{ margin: '20px 0 20px 0' }} />
        <div className="col-md-6 col-sm-12 col-md-pull-6" style={{ margin: '55px 0 20px 0' }}>
          <Typography
            className={classes.headline}
            style={{ marginBottom: 0 }}
          >{LandingPageContent.bodyHeadline1}
          </Typography>
          <Typography
            className={classes.headline}
            style={{ marginBottom: 40, marginTop: 1 }}
          >
            {LandingPageContent.bodyHeadline2}
          </Typography>
          <Typography style={{ fontSize: 14 }}>
            {LandingPageContent.bodyText}
          </Typography>
        </div>
      </div>
    );
  }

  renderBody2() {
    const { classes } = this.props;

    const image1 = (
      <div
        className={classes.appstoreInnerContainer}
      >
        <Typography style={{ fontSize: 12, fontWeight: 600, textAlign: 'center', marginBottom: 10 }}>
              Jetzt downloaden unter „customerexpert“
            </Typography>

        <a href={ENV.appStoreUrl}>
          <img src={appStore} width={120} alt="Goto Apple Store" />
        </a>
        <a href={ENV.playStoreUrl}>
          <img src={googlePlay} width={120} style={{ marginTop: 10 }} alt="Goto IOS Store" />
        </a>
      </div>
    );

    const image2 = (
      <img
        src={ThemeImages.landingpageBody2Image}
        className={`${classes.bodyImage} verticalAlign`}
        alt="body 2"
      />
    );

    return this.renderBlock(image2, image1, true);
  }

  renderFooter() {
    const { classes } = this.props;
    const menu = [
      { name: 'HOME', onClick: () => { } },
      { name: 'BENUTZER REGISTRIEREN', onClick: () => this.handleNavigateToRoute('benutzerregistrierung') },
      { name: 'LOGIN', onClick: () => this.handleNavigateToRoute('login') },
      { name: 'IMPRESSUM', onClick: () => { this.onLinkClicked(this.props.config.impressUrl); } },
      { name: 'DATENSCHUTZERKLÄRUNG', onClick: () => { this.onLinkClicked(this.props.config.privacyUrl); } },
      { name: 'ALLGEMEINE GESCHÄFTSBEDINGUNGEN', onClick: () => { this.onLinkClicked(LandingPageContent.agbUrl); } },
      { name: 'BILDQUELLENVERZEICHNIS', onClick: () => this.onLinkClicked(LandingPageContent.imageSourceList) },
    ];

    const poweredBy = (
      <div className={`${classes.poweredByContainer} col-sm-12`} onClick={() => this.onLinkClicked('https://www.smartlearningapp.com/')}>
        <div className={classes.poweredByInnerContainer}>
          <img src={poweredByLogo} className={`${classes.poweredByLogo} verticalAlign`} alt="powered by" />
          <Typography className={classes.poweredByText}>Umgesetzt von Smart learning</Typography>
        </div>
      </div>
    );

    const linkStyle = {
      textDecoration: 'none',
      color: 'grey',
      '&:hover': {
        fontWeight: 800,
      },
    };

    return (
      <div className={classes.footerContainer}>
        <div className="container">
          <div className="col-md-4 col-sm-12 col-md-12">
            <img src={ThemeImages.logoPath} style={{ maxWidth: 200 }} className="verticalAlign" alt="logo" />
          </div>
          <div className={`${classes.generalContainer} col-md-4 col-sm-12 col-md-12`}>
            <Typography className={classes.footerHeadline}>SITEMAP</Typography>
            {menu.map(m => <FooterButton onClick={m.onClick}>{m.name}</FooterButton>)}
          </div>
          <div className={`col-md-4 col-sm-12 col-md-12 ${classes.generalContainer}`}>
            <Typography className={classes.footerHeadline}>Kontakt</Typography>
            <Typography className={classes.footerText} component="div">{LandingPageContent.companyName} </Typography>
            <Typography className={classes.footerText} component="div">{LandingPageContent.companyName2} </Typography>
            <Typography className={classes.footerText} component="div">{LandingPageContent.companyAddress} </Typography>
            <Typography className={classes.footerText} component="div"><PhoneIcon className={classes.iconStyle} /> {LandingPageContent.companyPhone} </Typography>
            <Typography className={classes.footerText} component="div"><PrintIcon className={classes.iconStyle} /> {LandingPageContent.companyFax} </Typography>
            <Typography
              className={classes.footerText}
              component="div"
            >
              <MailIcon className={classes.iconStyle} />
              <a
                href={`mailto:${LandingPageContent.companyMail}`}
                style={linkStyle}
              >
                {LandingPageContent.companyMail}
              </a>
            </Typography>
          </div>
          {poweredBy}
        </div>
      </div>
    );
  }


  render() {
    return (
      <div>
        <Navbar history={this.props.history} />
        {this.renderHeader()}
        {this.renderAppPreview()}
        {this.renderVideo()}
        {this.renderFolder()}
        {/* {this.renderFolderArea()} */}
        {/* {this.renderBody3()} */}
        {this.renderBody()}
        {this.renderBody2()}
        {this.renderFooter()}
      </div>
    );
  }
}

Landingpage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = () => ({
  buttonContainer: {
    margin: '20px 0 40px 0',
  },
  headline: {
    fontSize: 38,
    marginTop: -15,
    marginBottom: 20,
    fontWeight: 400,
    textTransform: 'none',
  },
  footerHeadline: {
    fontWeight: 800,
    fontSize: 16,
    textTransform: 'uppercase',
  },
  footerText: {
    paddingTop: 5,
    color: 'grey',
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
  },
  footerContainer: {
    padding: '20px 0',
    background: '#f3f3f3',
  },
  iconStyle: {
    marginRight: 5,
  },
  poweredByText: {
    textTransform: 'uppercase',
    color: '#4AB873',
    fontSize: 14,
    marginLeft: 20,
    fontWeight: 800,
  },
  headerPreHeadline: {
    marginTop: 40,
    marginBottom: 20,
    fontWeight: 600,
  },
  headerImage: {
    maxHeight: 250,
    width: 'auto',
    marginTop: 20,
    marginBottom: 20,
  },
  headerImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  appstoreContainer: {
    maxWidth: 149,
    marginLeft: 20,
  },
  appstoreInnerContainer: {
    maxWidth: 200,
    // marginTop: 39,
    display: 'flex',
    flexDirection: 'column',
  },
  headerText: {
    fontWeight: 600,
    fontSize: 14,
  },
  poweredByLogo: {
    maxHeight: 60,
    width: 'auto',
  },
  bodyImage: {
    maxWidth: 800,
  },
  bodyContainer: {
    // display: 'flex',
    // alignItems: 'center',
    // flexWrap: 'wrap',
  },
  poweredByContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '20px 0 10px 0',
    cursor: 'pointer',
  },
  generalContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  poweredByInnerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
});

Landingpage.propTypes = {
  loggedIn: PropTypes.bool,
  config: PropTypes.object,
  navigateToLogin: PropTypes.func,
  navigateToSignup: PropTypes.func,

};

Landingpage.defaultProps = {
  loggedIn: false,
  config: null,
  navigateToLogin: () => { },
  navigateToSignup: () => { },
};

export default withStyles(styles)(Landingpage);



// WEBPACK FOOTER //
// ./src/app/landingpage__new/landingpage.js